// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"26e1bba5","513":"7273f824","703":"855cd6ea","787":"936ca4a3"}[chunkId] + ".chunk.js";
};